import { CSSObject } from '@chakra-ui/react';
import errorBg from '@/assets/epicodds/images/onboarding/bg.png';

export const LocationNotAllowedContainer: CSSObject = {
  h: undefined,
  justifyContent: 'center',
  alignItems: 'center',
  minH: '100dvh',
  fontFamily: 'Roboto',
  textAlign: 'center',
  bg: `url(${errorBg}) var(--bc-colors-alpha-900) center/cover no-repeat`,
};

export const CenterWrapper: CSSObject = {
  alignItems: 'center',
  color: 'white',
  gap: '0',
  h: undefined,
  justifyContent: 'center',
  maxW: '500px',
  mb: [null, null, '12'],
  minH: [null, null, '480px'],
  mt: ['0', null, '12'],
  mx: 'auto',
  pos: 'relative',
  px: ['4', null, '0'],
  py: ['3', null, '8'],
  textShadow: '0 4px 10px rgba(0, 0, 0, .2)',
  w: 'full',
  zIndex: '1',

  _before: {
    content: '""',
    h: '275px',
    left: '0',
    pos: 'absolute',
    top: '0',
    w: 'full',
    zIndex: '-1',
  },
};

export const FlexHeaderContainer: CSSObject = {
  display: 'flex',
  justifyContent: 'center',
};

export const ContentHeadingText: CSSObject = {
  color: 'beta.300',
  lineHeight: 'none',
  mb: '2.5',
  mt: '4',
  w: '100%',
  fontSize: ['sm', null, '2xl'],
  fontWeight: 'extrabold',
  textShadow: '0px 0px 8px rgba(255, 110, 32, 0.5)',
  textTransform: 'uppercase',
};

export const ContentBodyText: CSSObject = {
  fontSize: ['sm', null, 'md'],
  mb: '4',
  textAlign: 'center',
  color: 'white',
  fontWeight: 'semibold',
  fontFamily: 'body',
  '[class$="TextBodyCopy"]': {
    '.chakra-link': {
      fontWeight: 'bold',
      color: 'beta.300',
      fontSize: ['xs', null, 'sm'],
    },
  },
  div: {
    fontSize: ['xs', null, 'sm'],
  },
};

export const TextBodyCopy: CSSObject = {
  lineHeight: '5',
  mt: '4',
  fontWeight: 'normal',
};

export const RegistrationContent: CSSObject = {
  display: 'none',
};
